<template>
  <div class="bg-background-light font-sans min-h-screen flex flex-col relative overflow-hidden">
    <main class="flex-grow w-full flex items-center justify-center px-4 py-12 z-10">
      <div class="max-w-[440px] bg-white rounded-xl shadow-2xl shadow-slate-200/50 border border-slate-200 p-10 mx-auto">
        
        <div class="mb-10 text-center">
          <h1 class="text-pharma-text-main text-2xl font-black pb-2 tracking-tight">Palmiges Admin Portal</h1>
          <p class="text-pharma-text-muted text-sm font-medium leading-relaxed">
            Please enter your corporate credentials to access the secure portal.
          </p>
        </div>

        <div v-if="errorMessage" class="mb-6 p-4 bg-red-50 border-l-4 border-red-500 rounded-r-lg flex items-start gap-3">
          <span class="material-symbols-outlined text-red-500 text-[20px]">error</span>
          <p class="text-xs font-bold text-red-700 leading-tight">{{ errorMessage }}</p>
        </div>

        <form @submit.prevent="handleLogin" class="space-y-6">
          <div class="flex flex-col gap-2">
            <p class="text-pharma-text-main text-sm font-bold">Email</p>
            <input 
              v-model="email"
              type="email" 
              class="w-full rounded-lg border border-slate-200 h-12 px-4 text-sm focus:border-primary outline-none transition-all" 
              placeholder="e.g. Employee@pharmaco.com" 
              required
            />
          </div>

          <div class="flex flex-col gap-2">
            <div class="flex justify-between items-center">
              <p class="text-pharma-text-main text-sm font-bold">Password</p>
            </div>
            <div class="relative flex items-stretch">
              <input 
                v-model="password"
                :type="showPassword ? 'text' : 'password'" 
                class="w-full rounded-lg rounded-r-none border border-r-0 border-slate-200 h-12 px-4 text-sm outline-none" 
                placeholder="••••••••" 
                required
              />
              <div 
                @click="showPassword = !showPassword"
                class="flex items-center justify-center px-4 border border-slate-200 rounded-r-lg cursor-pointer bg-white"
              >
                <span class="material-symbols-outlined text-xl">
                  {{ showPassword ? 'visibility_off' : 'visibility' }}
                </span>
              </div>
            </div>
          </div>

          <button 
            type="submit" 
            :disabled="loading"
            class="w-full h-12 bg-primary text-white font-bold rounded-lg text-sm shadow-lg shadow-primary/20 transition-all flex items-center justify-center gap-2 disabled:opacity-70"
          >
            <span v-if="!loading">Login To Portal</span>
            <span v-else class="animate-spin material-symbols-outlined">progress_activity</span>
            <span v-if="!loading" class="material-symbols-outlined text-[20px]">login</span>
          </button>
        </form>
      </div>
    </main>

    </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'LoginPage',
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      loading: false,
      errorMessage: null
    }
  },
  methods: {
    async handleLogin() {
      this.loading = true;
      this.errorMessage = null;

      try {
        const response = await api.post('/admin/login', {
          email: this.email,
          password: this.password
        });

        // Store session
        localStorage.setItem('user-token', response.data.token);
        localStorage.setItem('user-data', JSON.stringify(response.data.user));
        
        // Setup default auth header
        api.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;

        this.$router.push('/dashboard');
      } catch (error) {
        // Display specific error from backend (Not Registered, Incorrect Password, or Role denied)
        this.errorMessage = error.response?.data?.message || "Connection error. Please try again.";
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>